import React from 'react'
import { SvgIcon } from '@mui/material'


export const PublicIcon = ({ sx, ...props }) => {
    return (
        <SvgIcon viewBox='0 0 39 39' {...{ sx: sx?.color ? { ...sx, stroke: sx.color, color: '#fff' , width: '40px', height: '40px'} : sx, ...props }}>
            <path xmlns="http://www.w3.org/2000/svg" d="M21.125 32.5V29.25C21.125 24.7627 17.4873 21.125 13 21.125C8.51269 21.125 4.875 24.7627 4.875 29.25V32.5H21.125ZM21.125 32.5H34.125V30.875C34.125 26.0885 30.4873 22.75 26 22.75C23.7033 22.75 21.6293 23.7664 20.1515 25.4005M17.875 11.375C17.875 14.0674 15.6924 16.25 13 16.25C10.3076 16.25 8.125 14.0674 8.125 11.375C8.125 8.68261 10.3076 6.5 13 6.5C15.6924 6.5 17.875 8.68261 17.875 11.375ZM29.25 14.625C29.25 16.4199 27.7949 17.875 26 17.875C24.2051 17.875 22.75 16.4199 22.75 14.625C22.75 12.8301 24.2051 11.375 26 11.375C27.7949 11.375 29.25 12.8301 29.25 14.625Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </SvgIcon>
    )
}
